'use client';
import { useEffect } from 'react';

const Hotjar = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') return;

    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: process.env['NEXT_PUBLIC_CREATOR_HOTJAR_SITE_ID'], hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }, []);

  return null;
};

export default Hotjar;
